import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'sb-comp-notice-box',
  templateUrl: './notice-box.component.html',
  styleUrls: ['./notice-box.component.scss'],
  standalone: false,
})
export class NoticeBoxComponent implements OnInit {
  @Input() type: string; // danger, warning, success

  constructor() {}

  ngOnInit(): void {}
}
